import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { EthicsComplianceAnswerModel } from 'src/app/Model/EthicsComplianceAnswer.model';
import { EthicsComplianceQuestionModel } from 'src/app/Model/EthicsComplianceQuestion.model';
import { RequestModel } from 'src/app/Model/Request.model';
import { ResponseData } from "../../Model/Base/Response";
import { BaseService } from '../Base/BaseService';
import { SessionStorageService } from '../sessionStorageService/session-storage.service';
import { AuthService } from '../Interceptor/auth.service';

@Injectable({
  providedIn: 'root'
})
export class EthicsComplianceService extends BaseService {

  constructor(public http: HttpClient, public lsService : SessionStorageService, authService: AuthService) { 
    super(http, lsService,authService);
    this.Component = "EthicsComplianceService";
  }

  public async getAnswersBySection(req:RequestModel) {
    let Response: EthicsComplianceAnswerModel[];
    await this.PostData(req, "EthicsCompliance", "GetAnswersBySection").then((res) => {
      if (res.head.status) {
        Response = JSON.parse(res.body.response);
      }
    });
    return Response;
  }

  public async getAnswersByRequest(req:RequestModel) {
    let Response: EthicsComplianceAnswerModel[];
    await this.PostData(req, "EthicsCompliance", "GetAnswersByRequest").then((res) => {
      if (res.head.status) {
        Response = JSON.parse(res.body.response);
      }
    });
    return Response;
  }

  public async getQuestionBySection(req:RequestModel) {
    let Response: EthicsComplianceQuestionModel[];
    await this.PostData(req, "EthicsCompliance", "GetQuestionBySection").then((res) => {
      if (res.head.status) {
        Response = JSON.parse(res.body.response);
      }
    });
    return Response;
  }

  public async put(data: EthicsComplianceAnswerModel) {
    let Res: ResponseData;
    await this.PostData(data, "EthicsCompliance", "Put").then((res) => {
      Res = res
    });
    return Res;
  }

  public async post(data: EthicsComplianceAnswerModel[]) {
    let Res: ResponseData;
    await this.PostData(data, "EthicsCompliance", "PostAnswers").then((res) => {
      Res = res
    });
    return Res;
  }
}
